import { snapshot } from 'valtio'
import { rpOccurrenceEditProxy } from '../RpOccurrenceDetail/CardUpdateSlideover/rpOccurrenceEditProxy'
import { type GlobalCustomerCardType } from '../../../../../../../shared/types/GlobalCustomerCardType'
import { creditCardListProxy } from '../../../../../../../shared/proxies/creditCardListProxy'
import { buildAxiosInstance } from '../../../../../../../shared/utils/apiUtils'

interface Response {
  data: {
    customerCards: GlobalCustomerCardType[]
  } | null
  error: string | null
}
export async function executeCustomerCardsSearchForRpOccurrenceEdit (): Promise<void> {
  creditCardListProxy.apiCallCustomerCardsSearch.loading = true
  creditCardListProxy.apiCallCustomerCardsSearch.error = null
  const { customer } = snapshot(rpOccurrenceEditProxy)
  try {
    const response = await buildAxiosInstance().post<Response>('/api/customer_cards/search', {
      customerId: String(customer?.id)
    })
    if (response.data.data) {
      creditCardListProxy.customerCards = response.data.data.customerCards
    } else {
      creditCardListProxy.apiCallCustomerCardsSearch.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      creditCardListProxy.apiCallCustomerCardsSearch.error = e.message
    }
  } finally {
    creditCardListProxy.apiCallCustomerCardsSearch.loading = false
  }
}
